import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BackArrow from "./BackArrow";
import classes from './BackArrowMenu.module.css';
import selectArrowIcon from '../../assests/ui/select-arrow.png';
import useClickOutside from "../../hooks/useClickOutside";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as PathRouter from '../../models/PathRoute'
import { coursesApi } from "../../utils";
import { fetchCoursesData } from "../../store/course-actions";
import { onKeyDown } from "../../service";

const BackArrowMenu = ({ title, description, onClick, select }) => {

    const { courses } = useSelector(state => state.courses);
    const { applicationId } = useSelector(state => state.application);
    const { direction } = useSelector(state => state.translate);

    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { uiData } = useSelector((state) => state.general);
    const [showSelect, setShowSelect] = useState(false);
    const [filterBy, setFilterBy] = useState(id);
    const [data, setData] = useState([])

    const selectRef = useRef(null);

    const handleSelect = value => {
        const updatedPath = window.location.pathname.replace(id, value).replace(uiData.baseName, '');
        navigate(updatedPath);
        setFilterBy(value);
        setShowSelect(false);
    };

    const getData = async () => {
        const coursesRangeFilter = { applicationId }
        coursesApi.coursesFilterRangePost({ coursesRangeFilter }, (error, resdata, response) => {
            if (resdata) {
                setData(resdata.map(p => ({ ...p, _name: p.name })))
            }
        })
    }

    useEffect(() => {
        if (!window.location.pathname.includes(PathRouter.PROFESSIONS)) {
            if ((!courses.length || (!courses.find(c => c.id === id) && state?.fetchCoursesData)) && applicationId) {
                dispatch(fetchCoursesData())
            }
            if (courses) {
                setData(courses.map(c => ({ ...c, _name: `${c.course?.name}, ${c.name}` })));
            }
        }
    }, [courses, applicationId])

    useEffect(() => {
        if (window.location.pathname.includes(PathRouter.PROFESSIONS)) {
            getData()
        }
    }, []);

    useClickOutside(selectRef, () =>
        setShowSelect(false)
    );

    const handleChangeSelect = e => {
        e.stopPropagation();
        setShowSelect(showSelect => !showSelect);
    }

    return (
        <div className={`${classes[direction]} ${classes.Container}`}>
            <BackArrow text={title} onClick={onClick} isMenu={true} />
            {description && <div className={classes.Description}>{description}</div>}
            {select && <div className={classes.SelectContainer}>
                <div className={classes.SelectWrapper}>
                    <div className={classes.SelectSelected} onClick={handleChangeSelect} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, handleChangeSelect)}>
                        <div className={classes.SelectedOptionText}>{data?.find(c => c.id === filterBy)?._name}</div>
                        <img src={selectArrowIcon} alt="SelectArrow" className={showSelect ? classes.SelectArrowIconOpen : classes.SelectArrowIconClose} />
                    </div>
                    {showSelect && <div ref={selectRef} className={classes.SelectDropDown}>
                        {data?.map(c => <div key={c.id} className={`${classes.Option} ${filterBy === c.id ? classes.SelectedOption : ''}`} onClick={() => handleSelect(c.id)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleSelect(c.id))}>{c._name}</div>)}
                    </div>}
                </div>
            </div>}
        </div>
    )
}

export default BackArrowMenu;